import { serviceHost } from "@/services";
import { useQuery } from "@tanstack/react-query";

export const useSourceDeals = (dealIds: string[]) => {
  const functionsService = serviceHost.getFunctionsService();
  return useQuery({
    queryKey: ["deals", "source", dealIds],
    queryFn: async () => {
      if (!dealIds || dealIds.length === 0) {
        return [];
      }
      return await functionsService.getDealsByIds({ dealIds });
    },
    enabled: !!dealIds && dealIds.length > 0,
  });
};
